import { Box, Button, Chip, Dialog, DialogActions, DialogTitle, Divider, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Paper, Select, Stack, Switch, Tab, TextField, Typography } from "@mui/material";
import { InvoicesList } from "../../../../components/InvoicesList";
import server from "../../../../services/server";
import { useState, useEffect } from "react";
import { useFetch } from "../../../../hooks/useFecth";
import useErrors from "../../../../hooks/useErrors";
import useDialog from "../../../../hooks/useDialog";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { payments } from "../../../../services/helpers";
import { useConfirm } from "material-ui-confirm";

function formatDatePt(value) {
    if (!value) return "—";
    try {
        return new Date(value).toLocaleDateString("pt-BR");
    } catch {
        return "—";
    }
}

function cycleLabel(cycle) {
    if (cycle === "MONTHLY") return "Mensal";
    if (cycle === "YEARLY") return "Anual";
    if (cycle === "WEEKLY") return "Semanal";
    if (cycle === "QUARTERLY") return "Trimestral";
    return cycle || "—";
}

function subscriptionStatusChip(signature) {
    if (!signature || Object.keys(signature).length === 0) {
        return { label: "Sem assinatura", color: "default" };
    }
    const due = signature.dueDateCycle;
    const isExpired = due && new Date(due) < new Date();
    if (["ACTIVE", "CONFIRMED", "RECEIVED"].includes(signature.paymentStatus) && !isExpired) {
        return { label: "Ativa", color: "success" };
    }
    if (isExpired) return { label: "Vencida", color: "error" };
    return { label: signature.status || "Inativa", color: "warning" };
}

function billingLabel(signature) {
    const key = (
        signature?.billingType ||
        signature?.paymentData?.billingType ||
        ""
    )
        .toString()
        .toLowerCase();
    return payments[key] || (signature?.billingType ? String(signature.billingType) : "—");
}

function SubscriptionSummary({ signature }) {
    const chip = subscriptionStatusChip(signature);
    const hasData = signature && Object.keys(signature).length > 0;

    return (
        <Paper variant="outlined" sx={{ p: 2, mb: 0, borderColor: "divider" }}>
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1.5 }}>
                Assinatura do clube
            </Typography>
            {!hasData ? (
                <Typography variant="body2" color="text.secondary">
                    Nenhuma assinatura vinculada a este clube.
                </Typography>
            ) : (
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant="caption" color="text.secondary" display="block">
                            Status
                        </Typography>
                        <Chip label={chip.label} color={chip.color} size="small" sx={{ mt: 0.5 }} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant="caption" color="text.secondary" display="block">
                            Plano
                        </Typography>
                        <Typography variant="body2">{signature.planData?.name || signature.Plan?.name || "—"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <Typography variant="caption" color="text.secondary" display="block">
                            Valor
                        </Typography>
                        <Typography variant="body2">
                            {signature.value != null
                                ? `R$ ${Number(signature.value).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`
                                : "—"}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <Typography variant="caption" color="text.secondary" display="block">
                            Ciclo
                        </Typography>
                        <Typography variant="body2">{cycleLabel(signature.cycle)}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <Typography variant="caption" color="text.secondary" display="block">
                            Próximo vencimento
                        </Typography>
                        <Typography variant="body2">{formatDatePt(signature.dueDateCycle)}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="caption" color="text.secondary" display="block">
                            Forma de pagamento
                        </Typography>
                        <Typography variant="body2">{billingLabel(signature)}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="caption" color="text.secondary" display="block">
                            Último pagamento
                        </Typography>
                        <Typography variant="body2">{formatDatePt(signature.lastPaymentAt)}</Typography>
                    </Grid>
                    {signature.subscriptionId != null && String(signature.subscriptionId) !== "" && (
                        <Grid item xs={12} sm={6} md={4}>
                            <Typography variant="caption" color="text.secondary" display="block">
                                ID assinatura Asaas
                            </Typography>
                            <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
                                {String(signature.subscriptionId)}
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            )}
        </Paper>
    );
}



// Dialog wrapper para manter compatibilidade
export function DialogInvoices({ club, mutateClub }) {
    const { open, handleClose } = useDialog('#invoices');
    const { data: invoices, isLoading, mutate } = useFetch(
        club?.id ? `clubs/${club.id}/subscriptions/asaas` : null
    );


    const signature = club?.Signature;

    const [paymentTab, setPaymentTab] = useState('subscription');


    // const invoicesFiltred = invoices?.filter(i => !i.deleted)


    if (!open) return null;

    // Separar invoices da assinatura, Orders e cobranças customizadas
    // Compatibilidade com formato antigo (apenas array) e novo (objeto com subscription, orders e customCharges)
    const subscriptionInvoices =
        invoices?.subscription || (Array.isArray(invoices?.data) ? invoices?.data : []);
    const orderCharges = invoices?.benefits || [];
    const customCharges = invoices?.customCharges || [];


    const handleChangeTab = (event, newValue) => setPaymentTab(newValue);


    const hasCustomProducts = customCharges.length > 0;
    const hasBenefits = club?.functions?.includes('benefit')


    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xl">

            <DialogTitle>Histórico de Faturas</DialogTitle>
            <Divider />

            <TabContext value={paymentTab}>
                <Box sx={{ border: 1, borderColor: 'divider', px: 2 }}>
                    <TabList onChange={handleChangeTab}>
                        <Tab label="Assinatura" value="subscription" />
                        {
                            hasCustomProducts && (
                                <Tab label="Customizados" value="custom" />
                            )
                        }
                        {
                            hasBenefits && (
                                <Tab label="Benefícios" value="benefits" />
                            )
                        }
                    </TabList>
                </Box>

                <TabPanel value="subscription" sx={{ p: 0 }}>
                    <Box sx={{ px: 2, pt: 2 }}>
                        <SubscriptionSummary signature={signature} />
                        <SubscriptionPayment dataPayments={subscriptionInvoices} mutate={mutate} club={club} isLoading={isLoading} mutateClub={mutateClub} />
                    </Box>

                </TabPanel>

                <TabPanel value="benefits" sx={{ p: 0 }}>
                    <BenefitsPayment dataPayments={orderCharges} mutate={mutate} club={club} isLoading={isLoading} />
                </TabPanel>

                <TabPanel value="custom" sx={{ p: 0 }}>
                    <CustomPayment dataPayments={customCharges} mutate={mutate} club={club} isLoading={isLoading} />
                </TabPanel>
            </TabContext>

            <DialogActions>
                <Button onClick={handleClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    );
}

function useSubscriptionDueDateUpdater(club, mutateInvoices, mutateClub) {
    const { enqueueSnackbar, setErrors } = useErrors();
    const [sendingDueDate, setSendingDueDate] = useState(false);
    const [subscriptionDueDate, setSubscriptionDueDate] = useState('');
    const [subscriptionPaymentValue, setSubscriptionPaymentValue] = useState('');
    const confirm = useConfirm();

    const handleUpdateSubscriptionDueDate = async (paymentIds = [], options = {}) => {
        const { alterarAssinatura = false, subscriptionCycle } = options;
        if (!club?.id) return;

        if (alterarAssinatura) {
            const hasDue = Boolean(subscriptionDueDate?.trim?.());
            const hasVal =
                subscriptionPaymentValue !== '' &&
                subscriptionPaymentValue != null &&
                String(subscriptionPaymentValue).trim() !== '';
            const assinaturaCycleBase =
                club?.Signature?.cycle === 'YEARLY' || club?.Signature?.cycle === 'MONTHLY'
                    ? club.Signature.cycle
                    : 'MONTHLY';
            const cicloAlterado =
                (subscriptionCycle === 'MONTHLY' || subscriptionCycle === 'YEARLY') &&
                subscriptionCycle !== assinaturaCycleBase;
            if (!hasDue && !hasVal && !cicloAlterado) {
                enqueueSnackbar('Informe o próximo vencimento, o valor e/ou altere o ciclo (mensal/anual).', { variant: 'warning' });
                return;
            }
            try {

                try {
                    await confirm({
                        title: `Tem certeza que deseja alterar a assinatura?`,
                        description: `Ao confirmar, não será possível desfazer a alteração.`,
                        confirmationText: 'Confirmo',
                        cancelText: 'Cancelar',
                    });
                } catch (error) {
                    setErrors(error);
                    return;
                }

                setSendingDueDate(true);
                await server.put(`clubs/${club.id}/subscription/asaas`, {
                    ...(hasDue ? { dueDate: subscriptionDueDate } : {}),
                    ...(hasVal ? { value: subscriptionPaymentValue } : {}),
                    ...(cicloAlterado ? { cycle: subscriptionCycle } : {}),
                });
                enqueueSnackbar('Assinatura atualizada com sucesso.');
                setSubscriptionDueDate('');
                setSubscriptionPaymentValue('');
                await mutateInvoices?.();
                await mutateClub?.();
            } catch (error) {
                setErrors(error);
            } finally {
                setSendingDueDate(false);
            }
            return;
        }

        if (!paymentIds?.length) return;

        const hasDueBulk = Boolean(subscriptionDueDate?.trim?.());
        const hasValBulk =
            subscriptionPaymentValue !== '' &&
            subscriptionPaymentValue != null &&
            String(subscriptionPaymentValue).trim() !== '';
        if (!hasDueBulk && !hasValBulk) {
            enqueueSnackbar('Informe o vencimento e/ou o valor da cobrança.', { variant: 'warning' });
            return;
        }

        try {
            setSendingDueDate(true);
            try {
                await confirm({
                    title: `Tem certeza que deseja alterar a cobrança?`,
                    description: `Ao confirmar, não será possível desfazer a alteração.`,
                    confirmationText: 'Confirmo',
                    cancelText: 'Cancelar',
                });
            } catch (error) {
                setErrors(error);
                return;
            }
            await server.put(`clubs/${club.id}/charges/duedate`, {
                ...(hasDueBulk ? { dueDate: subscriptionDueDate } : {}),
                paymentIds,
                ...(hasValBulk ? { value: subscriptionPaymentValue } : {}),
            });
            enqueueSnackbar('Cobrança atualizada com sucesso.');
            setSubscriptionDueDate('');
            setSubscriptionPaymentValue('');

            await mutateInvoices?.();

        } catch (error) {
            setErrors(error);
        } finally {
            setSendingDueDate(false);
        }
    };

    return {
        subscriptionDueDate,
        setSubscriptionDueDate,
        subscriptionPaymentValue,
        setSubscriptionPaymentValue,
        sendingDueDate,
        handleUpdateSubscriptionDueDate
    };
}

function useDeleteClubAsaasCharge(club, mutateInvoices) {
    const { enqueueSnackbar, setErrors } = useErrors();
    const confirm = useConfirm();
    const [deletingPaymentId, setDeletingPaymentId] = useState(null);

    const handleDeleteCharge = async (paymentId) => {
        if (!club?.id || !paymentId) return;
        try {
            try {
                await confirm({
                    title: 'Tem certeza que deseja excluir a cobrança?',
                    description: 'Ao confirmar, não será possível desfazer a exclusão.',
                    confirmationText: 'Confirmo',
                    cancelText: 'Cancelar',
                });
            } catch (error) {
                setErrors(error);
                return;
            }
            setDeletingPaymentId(String(paymentId));
            await server.delete(`clubs/${club.id}/charges/${encodeURIComponent(paymentId)}`);
            enqueueSnackbar('Cobrança excluída com sucesso.');
            await mutateInvoices?.();
        } catch (error) {
            setErrors(error);
        } finally {
            setDeletingPaymentId(null);
        }
    };

    return { handleDeleteCharge, deletingPaymentId };
}


function SubscriptionPayment({ dataPayments, club, isLoading, mutate, mutateClub }) {
    const [alterarAssinatura, setAlterarAssinatura] = useState(false);
    const [selectedPaymentIds, setSelectedPaymentIds] = useState([]);
    const [subscriptionCycle, setSubscriptionCycle] = useState('MONTHLY');

    useEffect(() => {
        if (alterarAssinatura) setSelectedPaymentIds([]);
    }, [alterarAssinatura]);

    useEffect(() => {
        if (!alterarAssinatura) return;
        const c = club?.Signature?.cycle;
        setSubscriptionCycle(c === 'YEARLY' || c === 'MONTHLY' ? c : 'MONTHLY');
    }, [alterarAssinatura, club?.Signature?.cycle]);

    const {
        subscriptionDueDate,
        setSubscriptionDueDate,
        subscriptionPaymentValue,
        setSubscriptionPaymentValue,
        sendingDueDate,
        handleUpdateSubscriptionDueDate
    } = useSubscriptionDueDateUpdater(club, mutate, mutateClub);

    const { handleDeleteCharge, deletingPaymentId } = useDeleteClubAsaasCharge(club, mutate);

    const labelVencimento = alterarAssinatura ? 'Próximo vencimento da assinatura' : 'Data de vencimento da cobrança';
    const labelValor = alterarAssinatura ? 'Valor da assinatura (mensalidade)' : 'Valor da parcela';
    const labelBotao = alterarAssinatura ? 'Alterar assinatura' : 'Alterar cobrança';
    const assinaturaCycleBase =
        club?.Signature?.cycle === 'YEARLY' || club?.Signature?.cycle === 'MONTHLY'
            ? club.Signature.cycle
            : 'MONTHLY';
    const cicloAlterado =
        (subscriptionCycle === 'MONTHLY' || subscriptionCycle === 'YEARLY') &&
        subscriptionCycle !== assinaturaCycleBase;
    const hasDueField = Boolean(subscriptionDueDate?.trim?.());
    const hasValField =
        subscriptionPaymentValue !== '' &&
        subscriptionPaymentValue != null &&
        String(subscriptionPaymentValue).trim() !== '';

    const desabilitarBotao = alterarAssinatura
        ? sendingDueDate || (!hasDueField && !hasValField && !cicloAlterado)
        : sendingDueDate || !Boolean(selectedPaymentIds.length);

    return (
        <>
            <Paper variant="outlined" sx={{ p: 2, borderColor: 'divider' }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Cobranças da Assinatura
                </Typography>
                <FormControlLabel
                    control={
                        <Switch
                            checked={alterarAssinatura}
                            onChange={(e) => setAlterarAssinatura(e.target.checked)}
                            color="primary"
                        />
                    }
                    label="Alterar assinatura no Asaas (não só a cobrança avulsa)"
                    sx={{ mb: 1, display: 'block' }}
                />
                <Stack direction="row" alignItems="center" gap={2} sx={{ mb: 2 }} flexWrap="wrap">
                    <TextField
                        label={labelVencimento}
                        type="date"
                        value={subscriptionDueDate}
                        onChange={(e) => setSubscriptionDueDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        size="small"
                        sx={{ minWidth: 220 }}
                    />
                    <TextField
                        label={labelValor}
                        type="number"
                        inputProps={{ step: '0.01', min: 0 }}
                        value={subscriptionPaymentValue}
                        onChange={(e) => setSubscriptionPaymentValue(e.target.value)}
                        size="small"
                        sx={{ minWidth: 180 }}
                    />
                    {alterarAssinatura && (
                        <FormControl size="small" sx={{ minWidth: 160 }}>
                            <InputLabel id="subscription-cycle-label">Ciclo</InputLabel>
                            <Select
                                labelId="subscription-cycle-label"
                                label="Ciclo"
                                value={subscriptionCycle}
                                onChange={(e) => setSubscriptionCycle(e.target.value)}
                            >
                                <MenuItem value="MONTHLY">Mensal</MenuItem>
                                <MenuItem value="YEARLY">Anual</MenuItem>
                            </Select>
                        </FormControl>
                    )}
                    <Button
                        variant="outlined"
                        onClick={() =>
                            handleUpdateSubscriptionDueDate(selectedPaymentIds, {
                                alterarAssinatura,
                                subscriptionCycle,
                            })
                        }
                        disabled={desabilitarBotao}
                    >
                        {sendingDueDate ? 'Enviando...' : labelBotao}
                    </Button>
                </Stack>
                <Divider sx={{ my: 4 }} />
                {dataPayments?.length > 0 ? (
                    <InvoicesList
                        club={club}
                        updateCard={false}
                        data={dataPayments}
                        isLoading={isLoading}
                        checkbox={!alterarAssinatura}
                        onSelectedPaymentIdsChange={setSelectedPaymentIds}
                        onDeleteCharge={handleDeleteCharge}
                        deletingPaymentId={deletingPaymentId}
                    />
                ) : (
                    <Box sx={{ textAlign: 'center', py: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                            Nenhuma cobrança da assinatura encontrada
                        </Typography>
                    </Box>
                )}
            </Paper>
        </>
    )
}

function CustomPayment({ dataPayments, club, isLoading, mutate }) {
    const {
        subscriptionDueDate,
        setSubscriptionDueDate,
        subscriptionPaymentValue,
        setSubscriptionPaymentValue,
        sendingDueDate,
        handleUpdateSubscriptionDueDate
    } = useSubscriptionDueDateUpdater(club, mutate, undefined);
    const [selectedPaymentIds, setSelectedPaymentIds] = useState([]);

    const { handleDeleteCharge, deletingPaymentId } = useDeleteClubAsaasCharge(club, mutate);

    const labelVencimento = 'Data de vencimento da cobrança';
    const labelValor = 'Valor da parcela';
    const desabilitarBotao = sendingDueDate || !Boolean(selectedPaymentIds.length);

    return (
        <Paper variant="outlined" sx={{ p: 2, borderColor: 'divider' }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Cobranças de Customização
            </Typography>
            <Stack direction="row" alignItems="center" gap={2} sx={{ mb: 2 }} flexWrap="wrap">
                <TextField
                    label={labelVencimento}
                    type="date"
                    value={subscriptionDueDate}
                    onChange={(e) => setSubscriptionDueDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    sx={{ minWidth: 220 }}
                />
                <TextField
                    label={labelValor}
                    type="number"
                    inputProps={{ step: '0.01', min: 0 }}
                    value={subscriptionPaymentValue}
                    onChange={(e) => setSubscriptionPaymentValue(e.target.value)}
                    size="small"
                    sx={{ minWidth: 180 }}
                />
                <Button
                    variant="outlined"
                    onClick={() => handleUpdateSubscriptionDueDate(selectedPaymentIds)}
                    disabled={desabilitarBotao}
                >
                    {sendingDueDate ? 'Enviando...' : 'Alterar cobrança'}
                </Button>
            </Stack>
            <Divider sx={{ my: 4 }} />
            {dataPayments?.length > 0 ? (
                <InvoicesList
                    club={club}
                    updateCard={false}
                    data={dataPayments}
                    isLoading={isLoading}
                    checkbox={true}
                    onSelectedPaymentIdsChange={setSelectedPaymentIds}
                    onDeleteCharge={handleDeleteCharge}
                    deletingPaymentId={deletingPaymentId}
                />
            ) : (
                <Box sx={{ textAlign: 'center', py: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Nenhuma cobrança encontrada
                    </Typography>
                </Box>
            )}
        </Paper>
    );
}

function BenefitsPayment({ dataPayments, club, isLoading, mutate }) {
    const {
        subscriptionDueDate,
        setSubscriptionDueDate,
        subscriptionPaymentValue,
        setSubscriptionPaymentValue,
        sendingDueDate,
        handleUpdateSubscriptionDueDate
    } = useSubscriptionDueDateUpdater(club, mutate, undefined);
    const [selectedPaymentIds, setSelectedPaymentIds] = useState([]);

    const { handleDeleteCharge, deletingPaymentId } = useDeleteClubAsaasCharge(club, mutate);

    const labelVencimento = 'Data de vencimento da cobrança';
    const labelValor = 'Valor da parcela';
    const desabilitarBotao = sendingDueDate || !Boolean(selectedPaymentIds.length);

    return (
        <Paper variant="outlined" sx={{ p: 2, borderColor: 'divider' }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Cobranças de Benefícios
            </Typography>
            <Stack direction="row" alignItems="center" gap={2} sx={{ mb: 2 }} flexWrap="wrap">
                <TextField
                    label={labelVencimento}
                    type="date"
                    value={subscriptionDueDate}
                    onChange={(e) => setSubscriptionDueDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    sx={{ minWidth: 220 }}
                />
                <TextField
                    label={labelValor}
                    type="number"
                    inputProps={{ step: '0.01', min: 0 }}
                    value={subscriptionPaymentValue}
                    onChange={(e) => setSubscriptionPaymentValue(e.target.value)}
                    size="small"
                    sx={{ minWidth: 180 }}
                />
                <Button
                    variant="outlined"
                    onClick={() => handleUpdateSubscriptionDueDate(selectedPaymentIds)}
                    disabled={desabilitarBotao}
                >
                    {sendingDueDate ? 'Enviando...' : 'Alterar cobrança'}
                </Button>
            </Stack>
            <Divider sx={{ my: 4 }} />
            {dataPayments?.length > 0 ? (
                <InvoicesList
                    club={club}
                    updateCard={false}
                    data={dataPayments}
                    isLoading={isLoading}
                    checkbox={true}
                    onSelectedPaymentIdsChange={setSelectedPaymentIds}
                    onDeleteCharge={handleDeleteCharge}
                    deletingPaymentId={deletingPaymentId}
                />
            ) : (
                <Box sx={{ textAlign: 'center', py: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Nenhuma cobrança encontrada
                    </Typography>
                </Box>
            )}
        </Paper>
    );
}